/* ============================================================
   Beneos Battlemaps : product detail interactions.
   Gallery thumbnail switching, video play, variant price.
   ============================================================ */
(function () {
  'use strict';
  var frame = document.getElementById('stageFrame');
  var thumbs = document.getElementById('thumbs');
  var stageVideo = document.getElementById('stageVideo');
  var stageTrailer = document.getElementById('stageTrailer');

  function trailerEmbed(u) {
    var yt = String(u).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = String(u).match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }
  function hideVideo() { if (stageVideo) { stageVideo.classList.add('is-hidden'); var v = stageVideo.querySelector('video'); if (v) v.pause(); } }
  function hideTrailer() { if (stageTrailer) { stageTrailer.classList.add('is-hidden'); stageTrailer.innerHTML = ''; } }

  if (thumbs) {
    Array.prototype.forEach.call(thumbs.querySelectorAll('.thumb'), function (t) {
      t.addEventListener('click', function () {
        Array.prototype.forEach.call(thumbs.querySelectorAll('.thumb'), function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        if (t.getAttribute('data-video') && stageVideo) {
          hideTrailer();
          stageVideo.classList.remove('is-hidden');
          var pv = stageVideo.querySelector('video');
          if (pv) { try { pv.play(); } catch (e) {} }
          return;
        }
        var trailer = t.getAttribute('data-trailer');
        if (trailer && stageTrailer) {
          hideVideo();
          var src = trailerEmbed(trailer);
          if (src) {
            stageTrailer.innerHTML = '<iframe src="' + src + '" title="Trailer" allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowfullscreen frameborder="0"></iframe>';
            stageTrailer.classList.remove('is-hidden');
          } else { window.open(trailer, '_blank', 'noopener'); }
          return;
        }
        var img = t.getAttribute('data-img');
        if (img && frame) { frame.style.backgroundImage = "url('" + img + "')"; }
        hideVideo();
        hideTrailer();
      });
    });
  }

  var playBtn = document.getElementById('playBtn');
  if (playBtn && stageVideo) {
    playBtn.addEventListener('click', function () {
      stageVideo.classList.remove('is-hidden');
      var v = stageVideo.querySelector('video'); if (v) { try { v.play(); } catch (e) {} }
    });
  }

  var sel = document.querySelector('select[data-variant-select]');
  if (sel) {
    var priceEl = document.getElementById('pPrice');
    var addBtn = document.querySelector('[data-add-btn]');
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var price = opt.getAttribute('data-price');
      if (priceEl && price) priceEl.textContent = price;
      var avail = opt.getAttribute('data-available') === 'true';
      if (addBtn) {
        addBtn.disabled = !avail;
        var addLabel = addBtn.getAttribute('data-add-label') || 'Add to cart';
        var soldLabel = addBtn.getAttribute('data-soldout-label') || 'Sold out';
        addBtn.textContent = avail ? addLabel : soldLabel;
      }
    });
  }
})();
